import { ShipmentMethod } from "../../../transportation/models/enums/shipment-method";
import { MetricBase } from "../shared/metric-base";

/**
 * The orders of a dealer that are picked up, or the orders that are delivered to a ship to address of a dealer
 */
export class UnplannedPickupMetricsGroup extends MetricBase {

    public dealerId : string = '';

    public dealerName : string = '';

    /** What the group is called: the dealer, and for a delivery its address after it */
    public name : string = '';

    public shipmentMethod : ShipmentMethod = ShipmentMethod.PickUp;

    /** The address of a group of deliveries */
    public shipToAddressId : number|undefined = undefined;

    /** The number the orders were given to split a dealer's pickups, or the deliveries to an address, into groups */
    public groupId : number = 0;

    /** Tells the group from the others in a table: a group of a dealer's pickups, or of the deliveries to an address */
    public get groupKey() : string {
        return this.shipmentMethod === ShipmentMethod.Delivery
            ? `delivery-${ this.shipToAddressId }-${ this.groupId }`
            : `pickup-${ this.dealerId }-${ this.groupId }`;
    }

}
